/* GC: PDP galeri küçük resim tıklaması. Masaüstünde fare basılıyken 1px bile kayınca
   xo-carousel-thumbnail tıklamayı sürükleme sayıp yutuyordu; 8px'e kadar kaymayı tıklama say. */
(function () {
  var d;
  document.addEventListener('mousedown', function (e) { d = [e.clientX, e.clientY]; }, true);
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('xo-carousel-thumbnail xo-carousel-slide');
    if (!s || !d) return;
    if (Math.hypot(e.clientX - d[0], e.clientY - d[1]) <= 8) {
      var l = s.closest('xo-carousel-list');
      if (l) l.isThumbMoving = false;
    }
  }, true);
})();
